import {Analytics, GTM, EventHub} from '@miro-site/analytics'

const analytics = new Analytics()

const getAnalytics = async (): Promise<Analytics> => {
  if (!analytics.isInitialized) {
    const providers = []

    if (process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID && process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH) {
      providers.push(
        // Init GTM
        new GTM(
          process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID,
          process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH,
          'env-5',
          'x',
          'dataLayer',
          {},
          {},
        ),
      )
    }

    if (
      process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_URL &&
      process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH &&
      process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT
    ) {
      const eventHubUrl = process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_URL

      providers.push(
        new EventHub(
          eventHubUrl,
          process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH,
          process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT,
        ),
      )
    }

    await analytics.initialize(providers)
  }

  return analytics
}

export default getAnalytics
